import React from 'react';
import PropTypes from 'prop-types';
import { Title } from '@glowforge/gf-styled/components/typography/Typography';

import {
  MeetFamilyWrapper,
  ProductsWrapper,
} from './meet-the-family-rebrand.styles';
import ProductCard from './product-card';

const MeetTheFamily = ({
  title,
  productsLink,
  products,
}) => {
  const productCards = products?.map((product) => (
    <ProductCard product={product} productsLink={productsLink} />
  ));

  return (
    <MeetFamilyWrapper variant='full'>
      <Title>{title}</Title>
      <ProductsWrapper>{productCards}</ProductsWrapper>
    </MeetFamilyWrapper>
  );
};

MeetTheFamily.propTypes = {
  title: PropTypes.string,
  productsLink: PropTypes.string,
  products: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
};

MeetTheFamily.defaultProps = {
  title: '',
  productsLink: '#',
  products: [],
};

export default MeetTheFamily;
